import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";
import MututualfundImg from "./../../../Images/home-products/mutual-fund.png"
import "./WelcomeMutualFund.css";
import { useCookies } from "react-cookie";
import TrackApi from "../../Activity_Track/TrackApi";
import { useEffect } from "react";
function WelcomeMutualFund() {
  const [cookies, setCookie] = useCookies(['LeadId']);
  let navigate = useNavigate();
  const routeChange = () => {
    let path = `/AllMutualFund`;
    navigate(path);
  };
  const trackData=(id)=>{
    const payloadData={
      "RelatedProspectId":id,
      "ActivityNote": "Your Mutual Fund Note",
      "mx_Custom_1": "Mutual Fund",
      "mx_Custom_2": "Mutual Fund page Note",
      "mx_CustomObject_81":window.location.href
     }
     TrackApi(payloadData);
  }
  useEffect(()=>{
  
if(cookies && cookies.RelatedProspectId){
  trackData(cookies.RelatedProspectId);
}
    
  },[])
  return (
    <>
      <section className="welcome-mutual">
        <Container>
          <Row>
            <Col lg={4} md={6} sm={12}>
              <div className="welcome-img-block">
                <img className="img-fluid" src={MututualfundImg} alt="EquityImg" />
              </div>
            </Col>
            <Col lg={8} md={6} sm={12}>
              <div className="welcome-mutual-beta">
                <h3>
                  <span>Mutual Fund</span>
                </h3>
                <p>
                A mutual fund is a financial vehicle that draws money from investors and invests those funds in various securities. The mutual fund's holdings are referred to as its portfolio. Professional money managers manage the fund and allocate funds in order to generate the best returns for the investors. Mutual funds invest in a wide range of securities, and performance is typically measured as the change in the fund's total market cap, which is derived from the aggregation of the underlying investments' performance. 
                </p>
                {/* <a onClick={routeChange}>
                  <span>Explore</span>
                </a>
                <button type="button">Sign Up</button> */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default WelcomeMutualFund;
